// import { ReportsComponent } from './report-details/reports';
// import { ReportFilterComponent } from './report-details/reportFilter/reportFilter';
// import { ReportDataComponent } from './report-details/reportData/reportData';
import { ReportSummeryDataComponent } from './report-summrize/reportData/reportData';
import { ReportsSummrizeComponent } from './report-summrize/reports';
import { ReportFilterSummrizeComponent } from './report-summrize/reportFilter/reportFilter';
import { downgradeComponent } from '@angular/upgrade/static';
// import { DeployedPackagesDetailsComponent } from './deployed-packages-details/deployed-details-packages.component';
import { ReportsAuditComponent} from './report-details-an7/reports-audit.component'

export default angular.module('reports', [])
    // .directive('deployedPackagesDetails',downgradeComponent({component:DeployedPackagesDetailsComponent}))
    .directive('reoortsAudit',downgradeComponent({component:ReportsAuditComponent}))
    // .component('reportsDetails',ReportsComponent)
    // .component('reportFilter',ReportFilterComponent)
    // .component('reportData',ReportDataComponent)
    .component('reportSummeryData',ReportSummeryDataComponent)
    .component('reportsSummrize',ReportsSummrizeComponent)
    .component('reportFilterSummrize',ReportFilterSummrizeComponent)



// WEBPACK FOOTER //
// ./src/app/authorized/reports/index.js